import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DbTemplate, DbTemplateFilter, DbTemplateInfo, DbTemplateItem } from '../db-template.model';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DbTemplateService } from '../db-template.service';

@Component({
    selector: 'app-db-template-info',
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './db-template-info.component.html'
})
export class DbTemplateInfoComponent implements OnInit{

  @Input() dbTemplateInfo!: DbTemplateInfo;

  isLoading: boolean = true;
  loadingText: string = 'Undersøger..';

  mandatoryFields: DbTemplateItem[] = [];
  keyFields: DbTemplateItem[] = [];
  defaultFields: DbTemplateItem[] = [];
  updateFields: DbTemplateItem[] = [];
  readFields: DbTemplateItem[] = [];
  hiddenFields: DbTemplateItem[] = [];

  filters: DbTemplateFilter[] = [];  
  readFilters: DbTemplateFilter[] = [];
  deleteFilters: DbTemplateFilter[] = [];  

  // Special for Stored Procedures
  paramterFields: DbTemplateItem[] = [];

  constructor(
    public activeModal: NgbActiveModal,
    private dbTemplateService: DbTemplateService,

  ) {}

  async ngOnInit(): Promise<void> {
    this.mandatoryFields = this.dbTemplateInfo.dbTemplateItems.filter(x => x.mandatory);
    this.keyFields = this.dbTemplateInfo.dbTemplateItems.filter(x => x.isKey);
    this.defaultFields = this.dbTemplateInfo.dbTemplateItems.filter(x => x.allowCreate && x.allowUpdate && ! x.mandatory && ! x.isSystemField && x.defaultValue != 'System: Null');
    this.updateFields = this.dbTemplateInfo.dbTemplateItems.filter(x => x.allowUpdate);
    this.hiddenFields = this.dbTemplateInfo.dbTemplateItems.filter(x => !x.allowRead && !x.allowUpdate && !x.mandatory);  

    if (this.dbTemplateInfo.dbTemplate.dbObjectType == 2) // Stored Procedure
    {
      this.paramterFields = this.dbTemplateInfo.dbTemplateItems.filter(x => x.origin == 4 && (!this.hiddenFields.some(h => h.id === x.id))); // SPParameter
      this.readFields = this.dbTemplateInfo.dbTemplateItems.filter(x => x.allowRead && x.origin != 4).sort((a, b) => Number(b.isKey) - Number(a.isKey)); // a - b = asc,  b -a = desc
    }
    else
    {
      this.readFields = this.dbTemplateInfo.dbTemplateItems.filter(x => x.allowRead).sort((a, b) => Number(b.isKey) - Number(a.isKey)); // a - b = asc,  b -a = desc
    }


    this.filters = await this.dbTemplateService.getDbTemplateFiltre(this.dbTemplateInfo.dbTemplate.id);
    this.readFilters = this.filters.filter(f => f.section === 'read');
    this.deleteFilters = this.filters.filter(f => f.section === 'delete');

    this.isLoading = false;
  }

  getFilerFieldname(dbTemplateItemId: string) : string
  {
    const item = this.dbTemplateInfo.dbTemplateItems.filter(x=>x.id == dbTemplateItemId)[0];
    if (item != null) 
      return item.name;
    return '';
  }


}
